import { useState, type MouseEvent } from "react";

export interface ContextMenuPosition {
  top: number;
  left: number;
}

/**
 * Minimal open/close state for a right-click menu anchored at the cursor,
 * used for the explorer's folder tree and empty-space pane menus. The
 * table's own per-row menu (which also supports the "more" button,
 * Shift+F10/ContextMenu and a long-press) lives in ExplorerTable itself,
 * since it needs one shared menu per row rather than one per component.
 */
export function useContextMenu() {
  const [position, setPosition] = useState<ContextMenuPosition | null>(null);

  function open(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    setPosition({ top: event.clientY, left: event.clientX });
  }

  function close() {
    setPosition(null);
  }

  return { position, open, close };
}
